export default "__VITE_PUBLIC_ASSET__1bf1382f__"